export const STATUS_PERSIST = "PERSIST";
export const STATUS_UPDATE = "UPDATE";
export const STATUS_REQUEST = "REQUEST";
export const STATUS_SUCCEED = "SUCCEED";
export const STATUS_FAILED = "FAILED";
export const ACTION_PERSIST = "PERSIST";
